// Client-side wrappers that proxy heavy computations to serverless functions.
// These functions are async and return the same-shaped results as the old sync utils.

const weaponSummaryCache = {};

async function fetchWeaponSummary(displayName) {
  if (weaponSummaryCache[displayName]) return weaponSummaryCache[displayName];
  try {
    const res = await fetch(`/.netlify/functions/weaponSummary?weapon=${encodeURIComponent(displayName)}`);
    if (!res.ok) return null;
    const data = await res.json();
    weaponSummaryCache[displayName] = data;
    return data;
  } catch (err) {
    console.error('fetchWeaponSummary error', err);
    return null;
  }
}

export async function getAttrTier(weaponDisplayName, urlName, isPositive) {
  const entry = await fetchWeaponSummary(weaponDisplayName);
  if (!entry) return null;
  const { mandatory = [], optional = [], accepted = [] } = entry;
  const canonicalizeAttrName = (n) => {
    if (!n) return n;
    const map = {
      'damage_vs_infested': 'infested_damage',
      'infested_damage': 'infested_damage',
      'damage_vs_corpus': 'corpus_damage',
      'corpus_damage': 'corpus_damage',
      'damage_vs_grineer': 'grineer_damage',
      'grineer_damage': 'grineer_damage',
    };
    return map[n] || n;
  };
  const canonicalUrl = canonicalizeAttrName(urlName);
  const mand = (mandatory || []).map(canonicalizeAttrName);
  const opt = (optional || []).map(canonicalizeAttrName);
  const acc = (accepted || []).map(canonicalizeAttrName);
  const isMandatory = mand.includes(canonicalUrl);
  const isOptional = opt.includes(canonicalUrl);
  if (isPositive === false) {
    if (acc.includes(canonicalUrl)) return 'ok';
    if (isMandatory) return 'badS';
    if (isOptional) return 'badA';
    return null;
  }
  if (isMandatory) return 'S';
  if (isOptional) return 'A';
  return null;
}

export function getAttrPlusValue(tier, isPositive) {
  if (isPositive === true) {
    if (tier === 'S') return 3;
    if (tier === 'A') return 2;
    return 1;
  }
  if (isPositive !== false) return 0;
  if (tier === 'ok') return 2;
  if (tier === 'badA') return -1;
  if (tier === 'badS') return -2;
  return 0;
}

export async function getRivenEvaluation(attrs, weaponDisplayName) {
  try {
    const res = await fetch('/.netlify/functions/evaluate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attrs, displayName: weaponDisplayName }),
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data.evaluation;
  } catch (err) {
    console.error('getRivenEvaluation error', err);
    return null;
  }
}